import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button, Card, Dropdown, Input, Modal, Tag } from "antd";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import VerticalThreeDotsIcon from "../../assets/images/share.svg";
import { renderList, setPartnerData } from "../../Reducer/globalSlice";
import {
  setInterestAndAssetType,
  setMicroSiteName,
  setOrganisationType,
  setPage,
  setPartnerId,
  setSector,
  setSubSector,
  setTabValue,
  updateZoom,
  setSize as localStorageSetSize,
  updateOrganisationNameById,
  setSearchName as updateSearchName,
  setSubSectorResponse,
  setOrganisationTypeLabel,
  setPartnerType,
} from "../../Reducer/localStorageSlice";
import { role } from "../../utils/constants";
import { deleteRequest, getRequest, postRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import lockIcon from "../../assets/images/lockIcon.png";
import shareIcon from "../../assets/images/share-icon.svg";
import favorite from "../../assets/newImages/Favorite.svg";
import favoriteActive from "../../assets/newImages/FavoriteActive.svg";
import youTubePlayButton from "../../assets/newImages/Play.svg";
import SynthesiaImage from "../../assets/newImages/synthesia.jpg";
import ytPlayBtn from "../../assets/newImages/Play.svg";
import ListIcon from "../../assets/newImages/list.svg";
import MapIcon from "../../assets/newImages/map.svg";
import {
  Back,
  CloseActive,
  SearchZoomActive,
} from "../../components/Icons/Icons";
import ShareLink from "../../components/ShareLink/ShareLink";
import Loader from "../../components/Loader/Loader";
import ModalPlayer from "../../components/PlayerModal/playerModal";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import {
  enumAndLabelAdapter,
  typeOfDevice as findTypeOfDevice,
} from "../../utils/util";
import MapView from "../home/MapView";
import "../home/MicroSites.scss";
import { inputFieldCharLimit } from "../../config";
import { getYouTubeVideoId } from "../../utils/helper";
import usePartnerName from "../../hooks/usePartnerName";
import { PARTNER_TYPE } from "../../utils/constants";
import FilterNew from "./FilterNew";
import { getInterestLabel, getSizeLabel, getTabValue } from "./filterConstants";
import {
  filterOrganizationsByBounds,
  primaryOrganizationPosition,
  sameMapBounds,
} from "../home/Map/markerCoordinates";
import {
  buildMapSearchPersistPayload,
  clearMapSearchPersistData,
  readMapSearchPersistData,
  readMapSearchPersistEnabled,
  writeMapSearchPersistData,
  writeMapSearchPersistEnabled,
} from "../../utils/mapSearchPersistence";

export default function MicroSitesNew() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectorData = useSelector((state) => state.global);
  const localData = useSelector((state) => state?.localStorage);
  const { formattedName: partner } = usePartnerName();
  const {
    partnerId,
    sector: sectorId,
    searchName: localDataSearchName,
    size: localDataSize,
    "Interest/AssetType": interestAssetType,
    subSector: subsectorId,
    accessToken: localDataAccessToken,
    OrganisationType,
    organisationTypeLabel,
    partnerType,
  } = localData;

  const typeOfDevice = findTypeOfDevice();

  const phoneNumber = selectorData?.userProfile?.phoneNumber;
  const accessToken = localDataAccessToken;

  const [loadingForOrgDirData, setLoadingForOrgDirData] = useState(false);
  const [masterDataIds, setMasterDataIds] = useState([]);
  const [orgDirectoryData, setOrgDirectoryData] = useState([]);

  const sentinelRef = useRef(null);
  const [orgDirPageSize] = useState(15);
  const [orgDirPageNumber, setOrgDirPageNumber] = useState(0);
  const isFetchingRef = useRef(false);
  const resetListingAfterMapSearchCancelRef = useRef(() => {});
  const resetMapSearchSessionRef = useRef(() => {});
  const skipAutoMicrositesFetchRef = useRef(false);
  const skipViewportStoreRef = useRef(false);

  const [microsites, setMicrosites] = useState();
  const [getSector, setGetSector] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updateFilterData, setUpdateFilterData] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [mediatype, setmediatype] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [af, setAf] = useState("");
  const [gl, setGl] = useState("");
  const [ms, setMs] = useState("");
  const [tz, setTz] = useState("");
  const [sectorName, setSectorName] = useState("");
  const [subSectorName, setSubSectorName] = useState("");
  const [boolaf, setBoolAf] = useState(false);
  const [boolgl, setBoolGl] = useState(false);
  const [boolms, setBoolMs] = useState(false);
  const [booltz, setBoolTz] = useState(false);
  const [searchText, setSearchText] = useState(localDataSearchName || "");
  const [showModal, setShowModal] = useState(false);
  const [bookmarkData, setBookmarkData] = useState([]);
  const [activeMicros, setActiveMicros] = useState("both");
  const [, setRadiusValue] = useState();
  const [selectedMicroSite, setSelectedMicroSite] = useState();
  const [mapFocusRequest, setMapFocusRequest] = useState(null);
  const [allowSetView, setAllowSetView] = useState(false);
  const [favMicroSites, setFavMicroSites] = useState(false);
  const [mapHeight, setMapHeight] = useState();
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);
  const [subSectors, setSubSectors] = useState([]);
  const [selectedInterest, setSelectedInterest] = useState(
    interestAssetType || null,
  );
  const [size, setSize] = useState(localDataSize || null);
  const [searchName, setSearchName] = useState(localDataSearchName || null);
  const [hasMoreOrgDir, setHasMoreOrgDir] = useState(true);
  const [totalData, setTotalData] = useState([]);
  const [viewportSnapshot, setViewportSnapshot] = useState(() => {
    if (!readMapSearchPersistEnabled()) return null;
    const persisted = readMapSearchPersistData();
    if (!persisted?.bounds) return null;
    return { bounds: persisted.bounds };
  });
  const [mapSearchQuery, setMapSearchQuery] = useState(() => {
    if (!readMapSearchPersistEnabled()) return "";
    return readMapSearchPersistData()?.query || "";
  });
  const [mapSearchLocked, setMapSearchLocked] = useState(() =>
    readMapSearchPersistEnabled(),
  );
  const [mapSearchRestoreToken, setMapSearchRestoreToken] = useState(() => {
    if (!readMapSearchPersistEnabled()) return 0;
    return readMapSearchPersistData()?.query ? Date.now() : 0;
  });
  const [mapSearchLocation, setMapSearchLocation] = useState(() => {
    if (!readMapSearchPersistEnabled()) return null;
    return readMapSearchPersistData()?.searchLocation || null;
  });
  const [mapSearchClearSignal, setMapSearchClearSignal] = useState(0);
  const [pendingViewportFit, setPendingViewportFit] = useState(false);
  const [trackedViewportKey, setTrackedViewportKey] = useState(null);
  const pendingViewportFitRef = useRef(false);
  const [dontShowOrgData, setDontShowOrgData] = useState(false);
  const [partnerLogo, setPartnerLogo] = useState(null);
  const { id } = useParams();

  const [organisationTypeName, setOrganisationTypeName] = useState(
    OrganisationType || null,
  );
  const [selectedOrganisationType, setSelectedOrganisationType] = useState(
    OrganisationType || null,
  );
  const baseUrl = window.location.origin;

  useEffect(() => {
    setDebouncedSearchText(localDataSearchName || "");
  }, [localDataSearchName]);

  const fetchMasterDataIds = useCallback(async () => {
    const response = await getRequest(userapiservice.getMasterDataIds());
    if (response?.length) {
      setMasterDataIds(response);
    }
  }, []);

  const fetchOrgDirectoryData = useCallback(
    async (partner, searchText, pageNumberOverride) => {
      if (!partner) return;
      if (isFetchingRef.current) return;
      isFetchingRef.current = true;
      setLoadingForOrgDirData(true);
      const pageNumber =
        pageNumberOverride === undefined
          ? orgDirPageNumber
          : pageNumberOverride;
      try {
        const response = await getRequest(
          userapiservice.getOrgDirectoryData({
            partner,
            searchText,
            pageNumber,
          }),
        );
        if (Array.isArray(response?.result)) {
          const totalFetched =
            orgDirectoryData?.length + response?.result?.length;
          if (
            response?.result?.length < orgDirPageSize ||
            totalFetched >= response?.totalCount
          ) {
            setHasMoreOrgDir(false);
          } else {
            setHasMoreOrgDir(true);
          }
          if (pageNumber === 0) {
            setOrgDirectoryData(response?.result);
          } else {
            setOrgDirectoryData((p) => [...p, ...(response?.result || [])]);
          }
        }
      } catch (err) {
      } finally {
        setTimeout(() => {
          isFetchingRef.current = false;
        }, 300);
        setLoadingForOrgDirData(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [orgDirPageNumber],
  );

  useEffect(() => {
    const partOne =
      microsites?.map((m) => ({
        ...m,
        isActual: true,
      })) || [];
    const partTwo = dontShowOrgData
      ? []
      : orgDirectoryData?.map((o) => ({
          ...o,
          isActual: false,
        })) || [];
    setTotalData([...partOne, ...partTwo]);
  }, [microsites, orgDirectoryData, dontShowOrgData]);

  const viewportFilterKey = [
    debouncedSearchText || "",
    selectedOrganisationType || "",
    selectedInterest || "",
    sectorId || "",
    subsectorId || "",
    size || "",
    af || "",
    gl || "",
    ms || "",
    tz || "",
    partnerType?.checked ? "1" : "0",
    favMicroSites ? "1" : "0",
  ].join("|");

  const focusMapOnResults = Boolean(
    String(debouncedSearchText || "").trim() ||
      selectedOrganisationType ||
      selectedInterest ||
      sectorId ||
      subsectorId ||
      size ||
      af ||
      gl ||
      ms ||
      tz ||
      partnerType?.checked ||
      favMicroSites,
  );

  if (trackedViewportKey !== viewportFilterKey) {
    setTrackedViewportKey(viewportFilterKey);
    pendingViewportFitRef.current = focusMapOnResults;
    setPendingViewportFit(focusMapOnResults);
  }

  const storeViewport = useCallback((bounds) => {
    if (!bounds) return;
    setViewportSnapshot((previous) => {
      if (sameMapBounds(previous?.bounds, bounds)) return previous;
      return { bounds };
    });
  }, []);

  const resetOrganisationListToInitial = useCallback(() => {
    setViewportSnapshot(null);
  }, []);

  const handleMapSearchQueryChange = useCallback((query) => {
    setMapSearchQuery(query || "");
  }, []);

  const handleMapSearchResultSelected = useCallback(
    (bounds, searchLocation) => {
      if (skipViewportStoreRef.current) return;
      storeViewport(bounds);
      if (searchLocation?.latitude != null && searchLocation?.longitude != null) {
        setMapSearchLocation({
          ...searchLocation,
          zoom: Number.isFinite(Number(bounds?.zoom))
            ? Number(bounds.zoom)
            : searchLocation.zoom,
        });
      }
    },
    [storeViewport],
  );

  const handleMapSearchCleared = useCallback(() => {
    resetMapSearchSessionRef.current();
  }, []);

  const canLockMapSearch = Boolean(
    mapSearchLocked ||
      String(mapSearchQuery || "").trim() ||
      (mapSearchLocation?.latitude != null && mapSearchLocation?.longitude != null),
  );

  const handleMapSearchLockToggle = useCallback(() => {
    if (mapSearchLocked) {
      resetMapSearchSessionRef.current();
      return;
    }

    const payload = buildMapSearchPersistPayload(
      mapSearchQuery || mapSearchLocation?.label,
      viewportSnapshot,
      mapSearchLocation,
    );
    if (!payload) return;

    writeMapSearchPersistEnabled(true);
    writeMapSearchPersistData(payload);
    setMapSearchLocked(true);
  }, [mapSearchLocked, mapSearchQuery, viewportSnapshot, mapSearchLocation]);

  const renderMapSearchLockControl = (extraClassName = "") => (
    <span
      role="button"
      tabIndex={0}
      aria-label={mapSearchLocked ? "Unlock map search" : "Lock map search"}
      title={mapSearchLocked ? "Unlock map search" : "Lock map search"}
      onClick={() => {
        if (!mapSearchLocked && !canLockMapSearch) return;
        handleMapSearchLockToggle();
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          if (!mapSearchLocked && !canLockMapSearch) return;
          handleMapSearchLockToggle();
        }
      }}
      className={`map-search-lock${extraClassName}${
        mapSearchLocked ? " map-search-lock--active" : ""
      }${canLockMapSearch ? "" : " map-search-lock--disabled"}`}
    >
      {mapSearchLocked ? <LockOutlined /> : <UnlockOutlined />}
    </span>
  );

  useEffect(() => {
    if (!mapSearchLocked) return;
    const payload = buildMapSearchPersistPayload(
      mapSearchQuery,
      viewportSnapshot,
      mapSearchLocation,
    );
    if (!payload) return;
    writeMapSearchPersistData(payload);
  }, [mapSearchLocked, mapSearchQuery, viewportSnapshot, mapSearchLocation]);

  const handleViewportChange = useCallback(
    (bounds) => {
      if (skipViewportStoreRef.current) return;
      if (pendingViewportFitRef.current) return;
      storeViewport(bounds);
    },
    [storeViewport],
  );

  const handleViewportFitted = useCallback(
    (bounds) => {
      pendingViewportFitRef.current = false;
      setPendingViewportFit(false);
      storeViewport(bounds);
    },
    [storeViewport],
  );

  const activeMapBounds = pendingViewportFit
    ? null
    : viewportSnapshot?.bounds ?? null;

  const visibleOrganizations = useMemo(
    () => filterOrganizationsByBounds(totalData, activeMapBounds),
    [totalData, activeMapBounds],
  );

  const listedOrganizations = useMemo(() => {
    const apps = visibleOrganizations.filter((item) => item?.isActual);
    const directory = visibleOrganizations.filter((item) => item && !item.isActual);
    const rows = [];
    if (apps.length) {
      rows.push({ type: "heading", id: "apps-heading", title: "Apps" });
    }
    apps.forEach((item, index) => {
      rows.push({ type: "item", id: `app-${item?.id || index}`, item });
    });
    if (directory.length) {
      rows.push({ type: "heading", id: "directory-heading", title: "Directory" });
    }
    directory.forEach((item, index) => {
      rows.push({ type: "item", id: `directory-${item?.id || index}`, item });
    });
    return rows;
  }, [visibleOrganizations]);

  const focusOrganisationOnMap = (microsite) => {
    const point = primaryOrganizationPosition(microsite, activeMapBounds);
    setSelectedMicroSite(microsite);
    setMapFocusRequest({
      token: Date.now(),
      latitude: point?.latitude ?? null,
      longitude: point?.longitude ?? null,
      microsite,
    });
  };

  const handleCardClick = (microsite) => {
    const name = microsite?.name;
    const formattedName = name.replace(/ /g, "_");
    dispatch(setMicroSiteName(formattedName));
    navigate(`/microsite/${formattedName}`, {
      state: { page: "home", logo: "logo" },
    });
  };

  useEffect(() => {
    if (skipAutoMicrositesFetchRef.current) return;
    fetchOrgDirectoryData(partner, debouncedSearchText);
  }, [partner, fetchOrgDirectoryData, debouncedSearchText, orgDirPageNumber]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
      setOrgDirPageNumber(0);
      setSearchName(searchText?.trim() ? searchText : null);
      dispatch(updateSearchName(searchText || ""));
    }, 500);
    return () => clearTimeout(timer);
  }, [searchText, dispatch]);

  useEffect(() => {
    fetchMasterDataIds();
  }, [fetchMasterDataIds]);

  useEffect(() => {
    const zoomValue = localStorage.getItem("zoom");
    if (!zoomValue) {
      dispatch(updateZoom(6));
      localStorage.setItem("zoom", 6);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeOfDevice !== "laptop" && selectorData?.list) {
      setActiveMicros("list");
      dispatch(renderList(false));
    } else if (typeOfDevice !== "laptop") {
      setActiveMicros("view");
    }
    setMapHeight(document.getElementById("list")?.offsetHeight);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeOfDevice]);

  const fetchSectorList = async () => {
    if (!partnerId) return;
    try {
      const response = await getRequest(
        userapiservice.getAllSectors(partnerId),
      );
      setGetSector(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (partner && partnerId) {
      fetchSectorList();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner, partnerId]);

  useEffect(() => {
    if (sectorId && getSector?.length > 0) {
      setSectorName(FindSectorName(sectorId));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSector, sectorId]);

  useEffect(() => {
    if (subsectorId && subSectors?.length > 0) {
      setSubSectorName(FindSubSectorName(subsectorId));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subSectors, subsectorId]);

  useEffect(() => {
    if (activeMicros === "both") {
      setRadiusValue(2);
    }
  }, [activeMicros]);

  const getPartnerDetails = async () => {
    if (!partner) return;
    setLoading(true);
    try {
      const response = await getRequest(
        userapiservice.getPartnerDetails(partner),
      );
      if (response) {
        setPartnerLogo(response);
        dispatch(setPartnerId(response?.id));
        dispatch(setPartnerData(response));
        setLoading(false);
      }
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    getPartnerDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner]);

  const getBookmark = async (updateToMicroSites = false) => {
    if(!partner) return;
    try {
      const response = await getRequest(
        userapiservice.getBookmark(phoneNumber, partner,role),
        undefined,
        false,
      );
      if (response) {
        setBookmarkData(response.microsites);
        if (updateToMicroSites) {
          setMicrosites(response?.microsites);
        }
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={
            error?.error || error?.message || "Sorry, Something went wrong"
          }
        />,
      );
    }
  };

  const postBookmark = async (id, name) => {
    try {
      const response = await postRequest(
        userapiservice.postBookmark(id, phoneNumber,role),
        null,
        false
      );
      if (response) {
        toast.success(
          <ToastComponent
            type={"Success"}
            message={`${name} added to favorites`}
          />,
        );
        getBookmark();
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={
            error?.error || error?.message || "Sorry, Something went wrong"
          }
        />,
      );
    }
  };

  const handleBookmark = (id, name) => {
    postBookmark(id, name);
  };

  useEffect(() => {
    if (partner && phoneNumber && accessToken) {
      getBookmark();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner, phoneNumber]);

  useEffect(() => {
    if (
      organisationTypeLabel ||
      selectedInterest ||
      sectorName ||
      subSectorName ||
      size
    ) {
      setDontShowOrgData(true);
    } else {
      setDontShowOrgData(false);
      setOrgDirPageNumber(0);
    }
  }, [
    organisationTypeLabel,
    selectedInterest,
    sectorName,
    subSectorName,
    size,
  ]);

  const fetchMicrosites = async (
    partner,
    partnerTypeId,
    organisationTypeName,
    interestName,
    sectorId,
    subsectorId,
    size,
    searchName,
    af,
    gl,
    ms,
    tz,
  ) => {
    if (!partner) return;
    setLoading(true);
    const searchText = encodeURIComponent(searchName || "");
    try {
      const masterDataValue = enumAndLabelAdapter(interestName);
      const masterDataId = masterDataIds?.find(
        (m) => m?.value === masterDataValue,
      )?.id;
      if (interestName) {
        if (!masterDataId) return;
      }

      await getRequest(
        userapiservice.filterMicrosites(
          partner,
          partnerTypeId,
          organisationTypeName,
          interestName,
          sectorId,
          subsectorId,
          size,
          searchText,
          af,
          gl,
          ms,
          tz,
          masterDataId,
        ),
        null,
        false,
      ).then((res) => {
        let output = [...res.result];
        setMicrosites([
          ...new Map(output.map((item) => [item["id"], item])).values(),
        ]);
        if (interestName) {
          dispatch(setInterestAndAssetType(interestName || ""));
          dispatch(setTabValue(getTabValue(interestName)));
        }
        setLoading(false);
      });
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
      setLoading(false);
    }
  };

  const resetListingAfterMapSearchCancel = useCallback(() => {
    if (!partner) return;

    dispatch(setPartnerType({ checked: false }));
    dispatch(setOrganisationTypeLabel(""));
    dispatch(setOrganisationType(""));
    dispatch(updateOrganisationNameById(""));
    dispatch(setInterestAndAssetType(""));
    dispatch(setTabValue(""));
    dispatch(setSector(""));
    dispatch(setSubSector(""));
    dispatch(localStorageSetSize(""));
    dispatch(updateSearchName(""));

    setOrganisationTypeName(null);
    setSelectedOrganisationType(null);
    setSelectedInterest(null);
    setSize(null);
    setSearchName(null);
    setSearchText("");
    setDebouncedSearchText("");
    setSectorName("");
    setSubSectorName("");
    setSubSectors(null);
    setAf("");
    setGl("");
    setMs("");
    setTz("");
    setBoolAf(false);
    setBoolGl(false);
    setBoolMs(false);
    setBoolTz(false);
    setOrgDirPageNumber(0);
    setHasMoreOrgDir(true);
    setOrgDirectoryData([]);

    fetchMicrosites(
      partner,
      null,
      null,
      null,
      null,
      null,
      null,
      "",
      "",
      "",
      "",
      "",
    );
    fetchOrgDirectoryData(partner, "", 0);
    setUpdateFilterData((previous) => !previous);
  }, [partner, dispatch, fetchOrgDirectoryData]);

  const resetMapSearchSession = useCallback(() => {
    skipAutoMicrositesFetchRef.current = true;
    skipViewportStoreRef.current = true;

    if (mapSearchLocked) {
      writeMapSearchPersistEnabled(false);
      clearMapSearchPersistData();
    }
    setMapSearchLocked(false);
    setMapSearchRestoreToken(0);
    setMapSearchQuery("");
    setMapSearchLocation(null);
    setViewportSnapshot(null);
    pendingViewportFitRef.current = false;
    setPendingViewportFit(false);
    setSelectedMicroSite(undefined);
    setMapFocusRequest(null);
    setFavMicroSites(false);
    setMapSearchClearSignal((value) => value + 1);

    resetListingAfterMapSearchCancelRef.current();

    window.setTimeout(() => {
      skipAutoMicrositesFetchRef.current = false;
      skipViewportStoreRef.current = false;
    }, 400);
  }, [mapSearchLocked]);

  useEffect(() => {
    resetListingAfterMapSearchCancelRef.current = resetListingAfterMapSearchCancel;
  }, [resetListingAfterMapSearchCancel]);

  useEffect(() => {
    resetMapSearchSessionRef.current = resetMapSearchSession;
  }, [resetMapSearchSession]);

  useEffect(() => {
    if (!partner) return;
    if (!partnerLogo || Object?.keys(partnerLogo)?.length === 0) return;
    if (skipAutoMicrositesFetchRef.current) return;
    fetchMicrosites(
      partner,
      partnerType?.checked ? partnerLogo?.partnerTypeId : null,
      selectedOrganisationType,
      selectedInterest,
      sectorId,
      subsectorId,
      size,
      debouncedSearchText,
      af,
      gl,
      ms,
      tz,
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    af,
    gl,
    ms,
    tz,
    masterDataIds,
    debouncedSearchText,
    partner,
    partnerLogo?.partnerTypeId,
    partnerType?.checked,
  ]);

  useEffect(() => {
    if (favMicroSites) {
      getBookmark(true);
    } else {
      fetchMicrosites(
        partner,
        partnerType?.checked ? partnerLogo?.partnerTypeId : null,
        selectedOrganisationType,
        selectedInterest,
        sectorId,
        subsectorId,
        size,
        debouncedSearchText,
        af,
        gl,
        ms,
        tz,
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favMicroSites, partner]);

  const handleFilterApply = (values) => {
    dispatch(setPartnerType({ checked: values.partnerTypeChecked }));
    dispatch(setOrganisationTypeLabel(values.organisationTypeLabel));
    dispatch(updateOrganisationNameById(values.organisationTypeLabel));
    dispatch(setOrganisationType(values.organisationTypeId));
    dispatch(setInterestAndAssetType(values.interest));
    dispatch(setSector(values.sectorId));
    dispatch(setSubSector(values.subSectorId));
    dispatch(localStorageSetSize(values.sizeId));
    dispatch(setTabValue(getTabValue(values.interest)));

    setSelectedInterest(values.interest);
    setOrganisationTypeName(values.organisationTypeId);
    setSelectedOrganisationType(values.organisationTypeId);
    setSize(values.sizeId);

    fetchMicrosites(
      partner,
      values.partnerTypeChecked ? partnerLogo?.partnerTypeId : null,
      values.organisationTypeId,
      values.interest,
      values.sectorId,
      values.subSectorId,
      values.sizeId,
      debouncedSearchText,
      af,
      gl,
      ms,
      tz,
    );
    setUpdateFilterData(!updateFilterData);
  };

  const RemoveHandler = (value) => {
    const doFetch = (
      partnerTypeId,
      orgType,
      interest,
      sector,
      subsector,
      sizeVal,
      search,
    ) => {
      fetchMicrosites(
        partner,
        partnerTypeId,
        orgType,
        interest,
        sector,
        subsector,
        sizeVal,
        search,
        af,
        gl,
        ms,
        tz,
      );
    };

    if (value === "partnerType") {
      dispatch(setPartnerType({ checked: false }));
      doFetch(
        null,
        organisationTypeName,
        selectedInterest,
        sectorId,
        subsectorId,
        size,
        debouncedSearchText,
      );
    }
    if (value === "organisationType") {
      setOrganisationTypeName(null);
      setSelectedOrganisationType(null);
      dispatch(setOrganisationTypeLabel(""));
      dispatch(setOrganisationType(""));
      dispatch(updateOrganisationNameById(""));
      doFetch(
        partnerType?.checked ? partnerLogo?.partnerTypeId : null,
        null,
        selectedInterest,
        sectorId,
        subsectorId,
        size,
        debouncedSearchText,
      );
    }
    if (value === "interest") {
      dispatch(setInterestAndAssetType(""));
      dispatch(setTabValue(""));
      setSelectedInterest(null);
      doFetch(
        partnerType?.checked ? partnerLogo?.partnerTypeId : null,
        organisationTypeName,
        null,
        sectorId,
        subsectorId,
        size,
        debouncedSearchText,
      );
    }
    if (value === "sector") {
      setSectorName("");
      dispatch(setSector(""));
      dispatch(setSubSector(""));
      setSubSectors(null);
      doFetch(
        partnerType?.checked ? partnerLogo?.partnerTypeId : null,
        organisationTypeName,
        selectedInterest,
        null,
        null,
        size,
        debouncedSearchText,
      );
    }
    if (value === "subsector") {
      setSubSectorName("");
      dispatch(setSubSector(""));
      doFetch(
        partnerType?.checked ? partnerLogo?.partnerTypeId : null,
        organisationTypeName,
        selectedInterest,
        sectorId,
        null,
        size,
        debouncedSearchText,
      );
    }
    if (value === "size") {
      setSize(null);
      dispatch(localStorageSetSize(""));
      doFetch(
        partnerType?.checked ? partnerLogo?.partnerTypeId : null,
        organisationTypeName,
        selectedInterest,
        sectorId,
        subsectorId,
        null,
        debouncedSearchText,
      );
    }
    if (value === "searchName") {
      setSearchName(null);
      setSearchText("");
      dispatch(updateSearchName(""));
      doFetch(
        partnerType?.checked ? partnerLogo?.partnerTypeId : null,
        organisationTypeName,
        selectedInterest,
        sectorId,
        subsectorId,
        size,
        null,
      );
    }
    setUpdateFilterData(!updateFilterData);
  };

  const FindSectorName = (id) => {
    let response = "";
    getSector.forEach((data) => {
      if (id === data.id) {
        response = data.name;
      }
    });
    return response;
  };

  const getSubSectorName = async (sectorId) => {
    if (!sectorId) return;
    try {
      setLoading(true);
      const response = await getRequest(
        userapiservice.getSubSectorsForFilter(sectorId),
      );
      setSubSectors(response);
      dispatch(setSubSectorResponse(response));
      setLoading(false);
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={
            error?.error || error?.message || "Sorry, Something went wrong"
          }
        />,
      );
      setLoading(false);
    }
  };

  const FindSubSectorName = (id) => {
    let response = "";
    subSectors?.forEach((data) => {
      if (id === data.id) {
        response = data.name;
      }
    });
    return response;
  };

  const removeBookmark = async (id, name) => {
    try {
      const response = await deleteRequest(
        userapiservice.removeBookmark(id, phoneNumber),
      );
      if (response) {
        getBookmark();
        toast.success(
          <ToastComponent
            type={"Success"}
            message={`${name} removed from favorites`}
          />,
        );
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={
            error?.error || error?.message || "Sorry, Something went wrong"
          }
        />,
      );
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  const PlayVideoHandler = (url, mediaType) => {
    setmediatype(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  useEffect(() => {
    getSubSectorName(sectorId);
    dispatch(setPage("home"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getSubSectorName(sectorId);
    dispatch(setPage("home"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectorId]);

  const handleAF = () => {
    if (!boolaf) {
      setAf("A-F");
      setBoolAf(true);
    } else {
      setAf("");
      setBoolAf(false);
    }
  };

  const handleGL = () => {
    if (!boolgl) {
      setGl("G-L");
      setBoolGl(true);
    } else {
      setGl("");
      setBoolGl(false);
    }
  };

  const handleMS = () => {
    if (!boolms) {
      setMs("M-S");
      setBoolMs(true);
    } else {
      setMs("");
      setBoolMs(false);
    }
  };

  const handleTZ = () => {
    if (!booltz) {
      setTz("T-Z");
      setBoolTz(true);
    } else {
      setTz("");
      setBoolTz(false);
    }
  };

  const extractSynthesiaId = (url) => {
    const match = url.match(
      /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/,
    );
    return match ? match[0] : null;
  };

  useEffect(() => {
    if (loading || loadingForOrgDirData) return;
    const container = document.querySelector(".list-container");
    const sentinel = sentinelRef.current;
    if (!container || !sentinel) return;
    if (
      activeMapBounds &&
      container.scrollHeight <= container.clientHeight + 1
    ) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !loadingForOrgDirData && hasMoreOrgDir) {
          setOrgDirPageNumber((p) => p + 1);
        }
      },
      {
        root: container,
        rootMargin: "200px",
        threshold: 0,
      },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, loadingForOrgDirData, visibleOrganizations, activeMapBounds]);

  const BackButtonClick = () => {
    setMicrosites(null);
    navigate("/");
  };

  return (
    <div className="microsites-container">
      <div className="search-and-filter-wrapper">
        <div className="arrow-container">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              BackButtonClick();
            }}
          >
            <Back />
          </div>
          <span className="title">Browse Organisations</span>
        </div>

        <div className="search-and-filter-container">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (accessToken) {
                setFavMicroSites(!favMicroSites);
              } else {
                setShowModal(true);
              }
            }}
          >
            <img
              src={favMicroSites ? favoriteActive : favorite}
              className="fav-icon"
              alt="favorites"
            />
          </div>
          <div className="title-bar-search-wrapper">
            <Input
              onChange={(e) => {
                setSearchText(e?.target?.value);
              }}
              value={searchText}
              placeholder="Search for Businesses"
              className="h-100 w-100"
              maxLength={inputFieldCharLimit}
              prefix={
                <SearchZoomActive customClassName="search-icon-landing-page" />
              }
              suffix={
                <span className="align-items-center d-flex gap-1">
                  {searchText?.length > 0 && (
                    <button
                      onClick={() => {
                        setSearchText("");
                      }}
                      className="button-wrapper"
                    >
                      <CloseActive customClassName="close-button" />
                    </button>
                  )}
                  <FilterNew
                    onApply={handleFilterApply}
                    popoverPlacement="topLeft"
                  />
                </span>
              }
            />
          </div>
          <div className="filter-container">
            <div>
              {!boolaf ? (
                <Button
                  id="A-F-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{ backgroundColor: "rgba(198, 164, 230, 0.7)" }}
                  onClick={handleAF}
                >
                  <span style={{ color: "white" }}>A-F</span>
                </Button>
              ) : (
                <Button
                  id="A-F-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{
                    backgroundColor: "rgba(198, 164, 230, 0.7)",
                    border: "1.5px solid #B771F9",
                    WebkitTransition: "all 200ms ease-in",
                    msTransition: "all 200ms ease-in",
                    MozTransition: "all 200ms ease-in",
                    transition: "all 200ms ease-in",
                    WebkitTransform: "scale(1.15)",
                    msTransform: "scale(1.15)",
                    MozTransform: "scale(1.15)",
                    transform: "scale(1.15)",
                    boxShadow: "rgb(38, 57, 77) 0px 20px 30px -10px",
                  }}
                  onClick={handleAF}
                >
                  <span style={{ color: "#fff", fontWeight: "bold" }}>A-F</span>
                </Button>
              )}
              {!boolgl ? (
                <Button
                  id="G-L-btn"
                  type="primary"
                  className="alpha-filter-btn alpha-filter"
                  style={{ backgroundColor: "rgba(242, 119, 148, 0.7)" }}
                  onClick={handleGL}
                >
                  <span style={{ color: "white" }}>G-L</span>
                </Button>
              ) : (
                <Button
                  id="G-L-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{
                    backgroundColor: "rgba(242, 119, 148, 0.7)",
                    border: "1.5px solid #FE3464",
                    WebkitTransition: "all 200ms ease-in",
                    msTransition: "all 200ms ease-in",
                    MozTransition: "all 200ms ease-in",
                    transition: "all 200ms ease-in",
                    WebkitTransform: "scale(1.15)",
                    msTransform: "scale(1.15)",
                    MozTransform: "scale(1.15)",
                    transform: "scale(1.15)",
                    boxShadow: "#FE3464 0px 20px 30px -10px",
                  }}
                  onClick={handleGL}
                >
                  <span style={{ color: "#fff", fontWeight: "bold" }}>G-L</span>
                </Button>
              )}
              {!boolms ? (
                <Button
                  id="M-S-btn"
                  type="primary"
                  className="alpha-filter-btn alpha-filter"
                  style={{ backgroundColor: "rgba(155, 224, 124, 0.7)" }}
                  onClick={handleMS}
                >
                  <span style={{ color: "white" }}>M-S</span>
                </Button>
              ) : (
                <Button
                  id="M-S-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{
                    backgroundColor: "rgba(155, 224, 124, 0.7)",
                    border: "1.5px solid #65AD45",
                    WebkitTransition: "all 200ms ease-in",
                    msTransition: "all 200ms ease-in",
                    MozTransition: "all 200ms ease-in",
                    transition: "all 200ms ease-in",
                    WebkitTransform: "scale(1.15)",
                    msTransform: "scale(1.15)",
                    MozTransform: "scale(1.15)",
                    transform: "scale(1.15)",
                    boxShadow: "#65AD45 0px 20px 30px -10px",
                  }}
                  onClick={handleMS}
                >
                  <span style={{ color: "#fff", fontWeight: "bold" }}>M-S</span>
                </Button>
              )}
              {!booltz ? (
                <Button
                  id="T-Z-btn"
                  type="primary"
                  className="alpha-filter-btn alpha-filter"
                  style={{ backgroundColor: "rgba(114, 225, 213, 0.7)" }}
                  onClick={handleTZ}
                >
                  <span style={{ color: "white" }}>T-Z</span>
                </Button>
              ) : (
                <Button
                  id="T-Z-btn"
                  className="alpha-filter-btn alpha-filter"
                  style={{
                    backgroundColor: "rgba(114, 225, 213, 0.7)",
                    border: "1.5px solid #1EB8A7",
                    WebkitTransition: "all 200ms ease-in",
                    msTransition: "all 200ms ease-in",
                    MozTransition: "all 200ms ease-in",
                    transition: "all 200ms ease-in",
                    WebkitTransform: "scale(1.15)",
                    msTransform: "scale(1.15)",
                    MozTransform: "scale(1.15)",
                    transform: "scale(1.15)",
                    boxShadow: "#1EB8A7 0px 20px 30px -10px",
                  }}
                  onClick={handleTZ}
                >
                  <span style={{ color: "#fff", fontWeight: "bold" }}>T-Z</span>
                </Button>
              )}
              {typeOfDevice !== "laptop" &&
                renderMapSearchLockControl(" map-search-lock--filter-row")}
            </div>
            {typeOfDevice !== "laptop" && (
              <img
                onClick={() => {
                  if (activeMicros === "list") {
                    setActiveMicros("view");
                  } else {
                    setActiveMicros("list");
                  }
                }}
                src={activeMicros === "list" ? MapIcon : ListIcon}
                className="toggle-img"
                alt="map"
              />
            )}
          </div>
        </div>
      </div>

      {organisationTypeLabel ||
      partnerLogo?.partnerTypeId ||
      selectedInterest ||
      sectorId ||
      subsectorId ||
      size ||
      searchName ? (
        <div className="filter-options">
          {organisationTypeLabel ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "organisationType")}
            >
              {organisationTypeLabel}
            </Tag>
          ) : null}
          {selectedInterest ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "interest")}
            >
              {getInterestLabel(selectedInterest)}
            </Tag>
          ) : null}
          {sectorName ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "sector")}
            >
              {FindSectorName(sectorId)}
            </Tag>
          ) : null}
          {subSectorName ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "subsector")}
            >
              {FindSubSectorName(subsectorId)}
            </Tag>
          ) : null}
          {size ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "size")}
            >
              {getSizeLabel(size)}
            </Tag>
          ) : null}
          {searchName ? (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "searchName")}
            >
              {searchName}
            </Tag>
          ) : null}
          {partnerType?.checked && (
            <Tag
              style={{ marginTop: "3px" }}
              closable
              onClose={RemoveHandler.bind(this, "partnerType")}
            >
              {PARTNER_TYPE[partnerLogo?.partnerType?.toLowerCase()]}
            </Tag>
          )}
        </div>
      ) : (
        ""
      )}

      <div id="list" className="list-and-view-container">
        {activeMicros === "both" || activeMicros === "list" ? (
          <div
            className="list-container"
            style={{ width: activeMicros === "list" && "100%" }}
          >
            <div className="arrows-wrapper">
              <div></div>
              <div className="arrows-container">
                {typeOfDevice === "laptop" ? (
                  <>
                    <div
                      onClick={() => {
                        setActiveMicros("both");
                      }}
                      className="arrows"
                    >
                      &larr;
                    </div>
                    <div
                      onClick={() => {
                        setActiveMicros("list");
                      }}
                      className="arrows"
                    >
                      &rarr;
                    </div>
                  </>
                ) : typeOfDevice === "tab" ? (
                  <img
                    onClick={() => {
                      setActiveMicros("list");
                    }}
                    src={ListIcon}
                    className="responsive-view-img"
                    alt="map"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>

            {(loading || loadingForOrgDirData) && orgDirPageNumber === 0 ? (
              <Loader />
            ) : (
              <>
                <motion.div
                  className={
                    activeMicros === "list"
                      ? visibleOrganizations && visibleOrganizations?.length === 0
                        ? "empty-micros"
                        : "list-card-container list-grid"
                      : visibleOrganizations && visibleOrganizations?.length === 0
                        ? "empty-micros"
                        : "list-card-container"
                  }
                >
                  {visibleOrganizations && visibleOrganizations?.length > 0 ? (
                    listedOrganizations.map((row) => {
                      if (row.type === "heading") {
                        return <></>;
                      }
                      const microsite = row.item;
                      if (microsite?.isActual) {
                        return (
                          <motion.div
                            key={row.id}
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{
                              duration: 0.8,
                              delay: 0.5,
                              ease: [0, 0.71, 0.2, 1.01],
                            }}
                            className="motion-wrapper"
                          >
                            <Card
                              style={{
                                border:
                                  selectedMicroSite?.isActual &&
                                  selectedMicroSite?.id &&
                                  selectedMicroSite.id === microsite?.id
                                    ? "1px solid red"
                                    : "",
                              }}
                              className="card-wrapper"
                            >
                              <div className="card-container">
                              
                                <div
                                  className="card-description-container"
                                  style={{ justifyContent: "start" }}
                                  onClick={() => {
                                    focusOrganisationOnMap(microsite);
                                    handleCardClick(microsite);
                                  }}
                                >
                                  <div className="micro-share-and-logo-container">
                                    <div className="logo-and-share-wrapper">
                                      <div className="logo-container">
                                        <img
                                          src={microsite?.micrositeLogo}
                                          alt={microsite?.name}
                                          className="microsite-preview-image"
                                        />
                                      </div>
                                    </div>
                                    {/* <div className="kebab-menu">
                                      <Dropdown
                                        trigger={["click"]}
                                        placement="bottomRight"
                                        overlay={
                                          <div
                                            className="microsite-dropdown"
                                            style={{
                                              border: "1px solid #f0f0f0",
                                              borderRadius: "4px",
                                              backgroundColor: "#fff",
                                              minWidth: "170px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                padding: "10px",
                                                borderBottom:
                                                  "1px solid #f0f0f0",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <div
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                                className="share-dropdown"
                                              >
                                                <ShareLink
                                                  shareUrl={`${baseUrl}/microsite/${microsite?.name?.replace(
                                                    / /g,
                                                    "_",
                                                  )}?partnerId=${partnerLogo?.id}`}
                                                  placement="leftTop"
                                                  triggerClassName="share-trigger tile-share-trigger"
                                                >
                                                  <div>
                                                    <img
                                                      src={shareIcon}
                                                      alt="share"
                                                    />
                                                    <span
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      Share
                                                    </span>
                                                  </div>
                                                </ShareLink>
                                              </div>
                                            </div>
                                            {phoneNumber && accessToken ? (
                                              bookmarkData.filter(
                                                (item) =>
                                                  item.id === microsite.id,
                                              ).length > 0 ? (
                                                <div
                                                  style={{
                                                    padding: "10px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                  }}
                                                  onClick={(e) => {
                                                    removeBookmark(
                                                      microsite.id,
                                                      microsite.name,
                                                    );
                                                    e.stopPropagation();
                                                  }}
                                                >
                                                  <img
                                                    width={18}
                                                    src={favoriteActive}
                                                    alt="Remove from Favorite"
                                                  />
                                                  <span
                                                    style={{
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    Remove from Favorite
                                                  </span>
                                                </div>
                                              ) : (
                                                <div
                                                  className="fav-wrapper"
                                                  style={{
                                                    padding: "10px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                  }}
                                                  onClick={(e) => {
                                                    handleBookmark(
                                                      microsite.id,
                                                      microsite.name,
                                                    );
                                                    e.stopPropagation();
                                                  }}
                                                >
                                                  <img
                                                    src={favorite}
                                                    alt="fav"
                                                  />
                                                  <span
                                                    style={{
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    Save as Favorite
                                                  </span>
                                                </div>
                                              )
                                            ) : (
                                              <div
                                                className="save-as-fav"
                                                style={{
                                                  padding: "10px",
                                                  cursor: "not-allowed",
                                                  opacity: 0.5,
                                                }}
                                              >
                                                <img
                                                  width={18}
                                                  className="save-as-fav-img"
                                                  src={favorite}
                                                  alt="Save as Favorite"
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "5px",
                                                  }}
                                                  onClick={(e) => {
                                                    toast.error(
                                                      <ToastComponent
                                                        type={"Error"}
                                                        message={
                                                          "Please login to access Favorites"
                                                        }
                                                      />,
                                                    );
                                                    e.stopPropagation();
                                                  }}
                                                >
                                                  Save as Favorite
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                        }
                                      >
                                        <div
                                          className="kebab-menu-inner"
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <img
                                            className="vertical-three-dots-icon"
                                            src={VerticalThreeDotsIcon}
                                            alt="vertical-three-dots-icon"
                                            style={{ cursor: "pointer" }}
                                          />
                                        </div>
                                      </Dropdown>
                                    </div> */}
                                  </div>
                                  {/* <p className="microsite-name">
                                    {microsite?.name}
                                  </p> */}
                                  <div className="microsite-name">
                                    {microsite?.businessDescription}
                                  </div>
                                  {microsite?.address ? (
                                    <p className="microsite-desc-address">
                                      <svg
                                        width="7"
                                        height="9"
                                        viewBox="0 0 7 9"
                                        fill="none"
                                      >
                                        <path
                                          d="M3.5 0C1.57 0 0 1.488 0 3.375C0 6.1875 3.5 9 3.5 9C3.5 9 7 6.1875 7 3.375C7 1.488 5.43 0 3.5 0ZM3.5 4.5C3.03587 4.5 2.59075 4.32237 2.26256 4.00888C1.93437 3.69538 1.75 3.26984 1.75 2.825C1.75 2.38016 1.93437 1.95462 2.26256 1.64113C2.59075 1.32763 3.03587 1.15 3.5 1.15C3.96413 1.15 4.40925 1.32763 4.73744 1.64113C5.06563 1.95462 5.25 2.38016 5.25 2.825C5.25 3.26984 5.06563 3.69538 4.73744 4.00888C4.40925 4.32237 3.96413 4.5 3.5 4.5Z"
                                          fill="#B0B0B0"
                                        />
                                      </svg>
                                      {microsite?.address}
                                    </p>
                                  ) : null}
                                </div>
                                <div className="card-image-container">
                                  {microsite.carouselLink?.mediaType ===
                                    "SOCIAL_MEDIA" &&
                                  microsite.carouselLink?.url ? (
                                    <>
                                      {(() => {
                                        const videoID = getYouTubeVideoId(
                                          microsite.carouselLink?.url,
                                        );
                                        if (!videoID) return null;
                                        return (
                                          <div
                                            className="media-image-container media1 youtube1"
                                            style={{
                                              objectFit: "contain",
                                              borderRadius: "8px",
                                            }}
                                            onClick={() =>
                                              PlayVideoHandler(
                                                `https://www.youtube.com/embed/${videoID}?autoplay=1&rel=0`,
                                                microsite.carouselLink?.mediaType
                                              )
                                            }
                                          >
                                            <img
                                              src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                                              alt=""
                                              className="video-preview-image image-preview"
                                            />
                                            {bookmarkData.filter(
                                              (item) =>
                                                item.id === microsite.id,
                                            ).length > 0 ? (
                                              <img
                                                className="bookMarked"
                                                src={favoriteActive}
                                                alt="bookmark"
                                              />
                                            ) : null}
                                            <img
                                              alt="play-button"
                                              className="play-button"
                                              src={youTubePlayButton}
                                            />
                                          </div>
                                        );
                                      })()}
                                    </>
                                  ) : microsite.carouselLink?.mediaType ===
                                      "VIMEO_MEDIA" &&
                                    microsite.carouselLink?.url ? (
                                    <div
                                      className="media-image-container media vimeo youtube"
                                      onClick={() => {
                                        PlayVideoHandler(
                                          microsite.carouselLink?.url,
                                          microsite.carouselLink?.mediaType
                                        );
                                      }}
                                    >
                                      <img
                                        src={`https://vumbnail.com/${microsite.carouselLink?.url?.split("/")[4]}.jpg`}
                                        alt={"video-preview"}
                                        className="video-preview-image image-preview"
                                      />
                                      {bookmarkData.filter(
                                        (item) => item.id === microsite.id,
                                      ).length > 0 ? (
                                        <img
                                          className="bookMarked"
                                          src={favoriteActive}
                                          alt="bookmark"
                                        />
                                      ) : null}
                                      <img
                                        alt="play-button"
                                        className="play-button"
                                        src={youTubePlayButton}
                                      />
                                    </div>
                                  ) : microsite.carouselLink?.mediaType ===
                                      "SYNTHESIA_MEDIA" &&
                                    microsite.carouselLink?.url ? (
                                    (() => {
                                      const videoId = extractSynthesiaId(
                                        microsite.carouselLink.url,
                                      );
                                      if (!videoId) return null;
                                      return (
                                        <div
                                          className="media-image-container media1 youtube1"
                                          onClick={() =>
                                            PlayVideoHandler(
                                              `https://share.synthesia.io/embeds/videos/${videoId}?autoplay=1`,
                                              microsite.carouselLink.mediaType
                                            )
                                          }
                                        >
                                          <img
                                            src={
                                              microsite?.carouselLink
                                                ?.thumbnailUrl || SynthesiaImage
                                            }
                                            alt="Synthesia Video"
                                            className="video-preview-image image-preview"
                                          />
                                          {bookmarkData.filter(
                                            (item) => item.id === microsite.id,
                                          ).length > 0 ? (
                                            <img
                                              className="bookMarked"
                                              src={favoriteActive}
                                              alt="bookmark"
                                            />
                                          ) : null}
                                          <img
                                            className="play-button"
                                            src={ytPlayBtn}
                                            alt="Play Button"
                                          />
                                        </div>
                                      );
                                    })()
                                  ) : (
                                    <div className="media">
                                      <div className="slider-Img">
                                        <img
                                          src={microsite.carouselLink?.url}
                                          alt=""
                                          className="home-preview-img"
                                        />
                                      </div>
                                      {bookmarkData.filter(
                                        (item) => item.id === microsite.id,
                                      ).length > 0 ? (
                                        <img
                                          className="bookMarked"
                                          src={favoriteActive}
                                          alt="bookmark"
                                        />
                                      ) : null}
                                    </div>

                                  )}
                                   <div className="kebab-menu">
                                      <Dropdown
                                        trigger={["click"]}
                                        placement="bottomRight"
                                        overlay={
                                          <div
                                            className="microsite-dropdown"
                                            style={{
                                              border: "1px solid #f0f0f0",
                                              borderRadius: "4px",
                                              backgroundColor: "#fff",
                                              minWidth: "170px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                padding: "10px",
                                                borderBottom:
                                                  "1px solid #f0f0f0",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <div
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                                className="share-dropdown"
                                              >
                                                <ShareLink
                                                  shareUrl={`${baseUrl}/microsite/${microsite?.name?.replace(
                                                    / /g,
                                                    "_",
                                                  )}?partnerId=${partnerLogo?.id}`}
                                                  placement="leftTop"
                                                  triggerClassName="share-trigger tile-share-trigger"
                                                >
                                                  <div>
                                                    <img
                                                      src={shareIcon}
                                                      alt="share"
                                                    />
                                                    <span
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      Share
                                                    </span>
                                                  </div>
                                                </ShareLink>
                                              </div>
                                            </div>
                                            {phoneNumber && accessToken ? (
                                              bookmarkData.filter(
                                                (item) =>
                                                  item.id === microsite.id,
                                              ).length > 0 ? (
                                                <div
                                                  style={{
                                                    padding: "10px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                  }}
                                                  onClick={(e) => {
                                                    removeBookmark(
                                                      microsite.id,
                                                      microsite.name,
                                                    );
                                                    e.stopPropagation();
                                                  }}
                                                >
                                                  <img
                                                    width={18}
                                                    src={favoriteActive}
                                                    alt="Remove from Favorite"
                                                  />
                                                  <span
                                                    style={{
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    Remove from Favorite
                                                  </span>
                                                </div>
                                              ) : (
                                                <div
                                                  className="fav-wrapper"
                                                  style={{
                                                    padding: "10px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                  }}
                                                  onClick={(e) => {
                                                    handleBookmark(
                                                      microsite.id,
                                                      microsite.name,
                                                    );
                                                    e.stopPropagation();
                                                  }}
                                                >
                                                  <img
                                                    src={favorite}
                                                    alt="fav"
                                                  />
                                                  <span
                                                    style={{
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    Save as Favorite
                                                  </span>
                                                </div>
                                              )
                                            ) : (
                                              <div
                                                className="save-as-fav"
                                                style={{
                                                  padding: "10px",
                                                  cursor: "not-allowed",
                                                  opacity: 0.5,
                                                }}
                                              >
                                                <img
                                                  width={18}
                                                  className="save-as-fav-img"
                                                  src={favorite}
                                                  alt="Save as Favorite"
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "5px",
                                                  }}
                                                  onClick={(e) => {
                                                    toast.error(
                                                      <ToastComponent
                                                        type={"Error"}
                                                        message={
                                                          "Please login to access Favorites"
                                                        }
                                                      />,
                                                    );
                                                    e.stopPropagation();
                                                  }}
                                                >
                                                  Save as Favorite
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                        }
                                      >
                                        <div
                                          className="kebab-menu-inner"
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <img
                                            className="vertical-three-dots-icon"
                                            src={VerticalThreeDotsIcon}
                                            alt="vertical-three-dots-icon"
                                            style={{ cursor: "pointer" }}
                                          />
                                        </div>
                                      </Dropdown>
                                    </div>
                                </div>
                                <div className="card-microsite-desc-footer">
                                  <div className="sector-and-sub-sector">
                                    {microsite?.sector &&
                                      microsite?.sector?.name && (
                                        <p className="microsite-sector">
                                          {microsite?.sector?.name}
                                        </p>
                                      )}
                                    {microsite?.subSector &&
                                      microsite?.subSector?.name && (
                                        <p className="microsite-sub-sector">
                                          {microsite?.subSector?.name}
                                        </p>
                                      )}
                                    {/* <img
                                      className="lock-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                      src={lockIcon}
                                      alt="lock"
                                    /> */}
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </motion.div>
                        );
                      } else {
                        return (
                          <motion.div
                            key={row.id}
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{
                              duration: 0.8,
                              delay: 0.5,
                              ease: [0, 0.71, 0.2, 1.01],
                            }}
                            className="motion-wrapper"
                            onClick={() => focusOrganisationOnMap(microsite)}
                          >
                            <Card
                              style={{
                                border:
                                  !selectedMicroSite?.isActual &&
                                  selectedMicroSite?.id &&
                                  selectedMicroSite.id === microsite?.id
                                    ? "1px solid red"
                                    : "1px solid black",
                              }}
                              className="card-wrapper"
                            >
                              <div className="card-container org-directory-card">
                                <div className="d-flex flex-column text-center">
                                  <div className="name">{microsite?.name}</div>
                                  <div>{microsite?.address}</div>
    
                                  {microsite?.phoneNumber && <div>
                                    <span>Phone number: </span>
                                    <span>{microsite?.phoneNumber || '--'}</span>
                                  </div>}
                                  {microsite?.email && <div>
                                    <span>Email: </span>
                                    <span>{microsite?.email || '--'}</span>
                                  </div>}
                                  <div>
                                  {microsite?.website &&  <>
                                  <span>Website: </span>
                                  <a
                                      title={microsite?.website}
                                      href={microsite?.website}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "#2563eb", textDecoration: "underline" }}
                                      onClick={(event) => event.stopPropagation()}
                                    >
                                      {microsite.website?.slice(0,70)}{microsite?.website?.length > 70 ? '...' : ''}
                                    </a>
                                    </>}
                                </div>
                                </div>
                              </div>
                            </Card>
                          </motion.div>
                        );
                      }
                    })
                  ) : (
                    <div className="empty-micros">
                      {visibleOrganizations && visibleOrganizations?.length === 0 && (
                        <div>
                          "Sorry there are no organisations at present for this
                          search so try removing filters"
                        </div>
                      )}
                    </div>
                  )}
                </motion.div>
                {hasMoreOrgDir && !dontShowOrgData && (
                  <div ref={sentinelRef} style={{ height: 1 }} />
                )}
              </>
            )}
          </div>
        ) : null}

        <div
          className="view-container"
          style={{
            ...(activeMicros === "view" ? { width: "100%" } : {}),
            ...(activeMicros === "list" ? { display: "none" } : {}),
          }}
        >
          <div className="arrows-wrapper">
            <div></div>
            <div className="arrows-toolbar">
              {typeOfDevice === "laptop" && renderMapSearchLockControl("")}
              <div className="arrows-container">
              {typeOfDevice === "laptop" ? (
                <>
                  <div
                    onClick={() => {
                      setActiveMicros("both");
                    }}
                    className="arrows"
                  >
                    &larr;
                  </div>
                  <div
                    onClick={() => {
                      setActiveMicros("view");
                    }}
                    className="arrows"
                  >
                    &rarr;
                  </div>
                </>
              ) : typeOfDevice === "tab" ? (
                <img
                  onClick={() => {
                    setActiveMicros("list");
                  }}
                  src={ListIcon}
                  className="responsive-view-img"
                  alt="map"
                />
              ) : (
                ""
              )}
              </div>
            </div>
          </div>
          <MapView
            id="mav-view"
            className="ant-map"
            businessCardHeight={mapHeight * 0.6}
            expandMap={false}
            disableSetView={() => {
              setAllowSetView(false);
            }}
            microSitesData={microsites}
            orgDirectoryData={orgDirectoryData}
            focusResults={focusMapOnResults}
            viewportBounds={activeMapBounds}
            onViewportChange={handleViewportChange}
            onViewportFitted={handleViewportFitted}
            onOrganisationListReset={resetOrganisationListToInitial}
            mapSearchQuery={mapSearchQuery}
            onMapSearchQueryChange={handleMapSearchQueryChange}
            onMapSearchCleared={handleMapSearchCleared}
            onMapSearchResultSelected={handleMapSearchResultSelected}
            mapSearchLocked={mapSearchLocked}
            mapSearchRestoreToken={mapSearchRestoreToken}
            mapSearchRestoreLocation={mapSearchLocation}
            mapSearchClearSignal={mapSearchClearSignal}
            isMapVisible={activeMicros !== "list"}
            focusRequest={mapFocusRequest}
            selectedData={(val) => {
              setSelectedMicroSite(val);
            }}
            cardData={selectedMicroSite}
            cardState={selectedMicroSite ? true : false}
            previewCardState={
              Object.keys(selectedMicroSite || {})?.length ? true : false
            }
            allowSetView={allowSetView}
          />
        </div>
      </div>

      {showModal && (
        <Modal
          open={showModal}
          onCancel={() => setShowModal(false)}
          footer={false}
        >
          <div>
            <div
              className="info-container"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flexGrow: "1",
                justifyContent: "center",
              }}
            >
              <img src={lockIcon} alt="Partner Logo" />
              <span className="text-to-contact-info">
                Please login to access Favorites
              </span>
              <button
                type="button"
                style={{
                  color: "#3067AE",
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                className="text-to-contact-info"
                onClick={() => {
                  navigate("/login", { state: { id, page: "microsite" } });
                }}
              >
                Login
              </button>
            </div>
          </div>
        </Modal>
      )}

      {isModalOpen && (
        <ModalPlayer
          closeModal={handleCancel}
          mediaLink={videoUrl}
          mediaType={mediatype}
          />
        )}
    </div>
  );
}